// ####################################################################
// #                  MAIN ROUTE INITIALIZING MODULE                  #
// ####################################################################

// Statische Importe von Modulen
import {
    expandButtons,
    flipIngrediantCards,
    carousel,
    verticalVideoSlider,
    hideCartButtonIfSanawissen,
    initAffiliateMedia,
    initProductTabs

} from './modules/animations.js';

import {
    replaceSvgIcon,
    adjustProductNameFontSize,
    adjustProductNameFontSize_headlining,
    checkProbeArtikel,
} from './modules/styling.js';

import {
    checkInputs,
    validateAddressStreetField,
    checkAddressContent,
    initializeDropzone
} from './modules/form-validation.js';

import {
    blockUserByAddress,
    startAlertLoop,
} from './modules/user-blocking.js';

import {
    observeOffcanvasElement,
    onBlurPromotionAction
} from './modules/shopping.js';

function loadAnimationModule() {
    hideCartButtonIfSanawissen();
    expandButtons();
    flipIngrediantCards();
    initAffiliateMedia(
        '.am-product-item',    // CSS-Selector für Sidebar-Items
        '.am-preview',         // Container der Vorschaubox
        '#am-preview-img',     // IMG-Tag in der Vorschaubox
        200                    // Fade-Dauer in ms
    );

    initProductTabs(
        '.am-product-item',    // CSS-Selector für Sidebar-Items
        '.am-post-section',    // CSS-Selector für Content-Sections
        'active',              // CSS-Klasse für aktives Sidebar-Item
        'hidden'               // CSS-Klasse, um Sektionen auszublenden
    );


    const currentPath = window.location.pathname;

    if (currentPath === '/') {
        // Startseite
        carousel('.we-carousel');
    }

    if (currentPath.startsWith('/sanawissen')) {
        carousel('.we-carousel');
        verticalVideoSlider('.vertical-video-container');

        // Beispiel: bestimmtes Element im Pfad /sanawissen verbergen
        const navbar = document.querySelector('.dropdown-menu-list');
        if (navbar) navbar.style.display = 'none';
    } else {
        const navbar = document.querySelector('.dropdown-menu-list');
        if (navbar) navbar.style.display = 'grid';
    }


    if (currentPath === '/dvsn/affiliate') {
        const containerSelection = document.querySelector('#content-main > div:nth-child(2)');
        if (containerSelection) {
            containerSelection.style.maxWidth = '90%';
        }
    }
}

function loadStylingModule() {
    replaceSvgIcon();
    adjustProductNameFontSize_headlining('.product-detail-name');
    adjustProductNameFontSize_headlining('.big-heading-line');
    adjustProductNameFontSize_headlining('.article-heading');
    checkProbeArtikel();
}


function loadFormValidationModule() {
    if (window.location.href.includes('/checkout/register')) {
        blockUserByAddress();
    }

    if (window.location.href.includes('/checkout/confirm')) {
        checkAddressContent();
        validateAddressStreetField();
    }

    if (window.location.href.includes('/account/login')) {
        checkInputs();
    }
}

function loadShoppingModule() {
    observeOffcanvasElement();

    if (window.location.href.includes('/checkout/cart')) {
        onBlurPromotionAction();
    }
}

/**
 *  Funktion zur Überprüfung, ob der Medien-Tab tatsächlich gerade sichtbar ist.
 * Wenn ja, führt sie initAffiliateMedia() und initProductTabs() erneut aus.
 */
function initializeMediaTab() {

    if (window.location.href.includes('/dvsn/affiliate')) {
        const mediaTabLink = document.querySelector('#account-affiliate-media-tab');
        const mediaTabPane = document.querySelector('#account-affiliate-media-pane');

        if (!mediaTabLink || !mediaTabPane) {
            return;
        }

        const isLinkActive = mediaTabLink.classList.contains('active');
        const isPaneVisible =
            mediaTabPane.classList.contains('show') &&
            mediaTabPane.classList.contains('active');

        if (!(isLinkActive && isPaneVisible)) {
            return;
        }

        initAffiliateMedia(
            '.am-product-item',     // Sidebar‐Items
            '.am-preview',          // Vorschau‐Box
            '#am-preview-img',      // IMG‐Tag in der Vorschau
            200                     // Fade‐Dauer in ms
        );
        initProductTabs(
            '.am-product-item',     // Sidebar‐Items
            '.am-post-section',     // Content‐Sektionen
            'active',               // CSS‐Klasse, die das aktive <li> hervorhebt
            'hidden'                // CSS‐Klasse, die den Content ausblendet
        );
    }
}

function initializeModules() {
    // Partnerportal Module
    initializeMediaTab();
    const mediaTabLink = document.querySelector('#media-tab');
    if (mediaTabLink) {
        mediaTabLink.addEventListener('shown.bs.tab', () => {
            initializeMediaTab();
        });
    }

    // Globale Module
    loadAnimationModule();
    loadStylingModule();

    // Bedingte Module
    loadFormValidationModule();
    loadShoppingModule();
}

// Initialisierung bei DOMContentLoaded
document.addEventListener('DOMContentLoaded', initializeModules);